export const mapTechnology = ({
	id,
	itApplicationName: name,
	itApplicationTypeID: type,
	scots,
	controls,
	knowledgeITApplicationId,
	relatedDocuments = null,
	parentITApplications,
	hasRelatedSCOT,
	isSupportingSCOTUserRequired,
	isSupportingIT,
	isSupportingITUserRequired,
	strategyTypeId,
	itControlStrategyTypeId,
	category,
	rationale,
	relatedTasks,
	itRisks,
	parentITControls,
	scotAndEstimates,
	itProcesses
}) => ({
	id,
	name,
	type,
	scots,
	controls,
	knowledgeITApplicationId,
	relatedDocuments,
	parentITApplications,
	hasRelatedSCOT,
	isSupportingSCOTUserRequired,
	isSupportingIT,
	isSupportingITUserRequired,
	strategyTypeId,
	itControlStrategyTypeId,
	category,
	rationale,
	relatedTasks,
	itRisks,
	parentITControls,
	scotAndEstimates,
	itProcesses
});

export default (response) => ({
	...response,
	data: response?.data?.map(mapTechnology)
});
